// extracted by mini-css-extract-plugin
export default {"participantContainer":"style_participantContainer__YJm-l","jump":"style_jump__LdVrm"};